import axios from "axios";
import { toast } from "react-toastify";

// Get Roles
export const getWorkPlaceistories = async () => {
	const { data } = await axios.get(
		`workPlaceHistory?status=true&page=1&count=20`
	);

	return data;
};

// Create Role

export const addWorkPlaceHistory = async (values) => {
	try {
		const { data } = await axios({
			method: "post",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `workPlaceHistory`,
			data: {
				...values,
			},
		});
		//dispatching data
		toast.success("Added successful");

		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in adding designation History again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
};

// Detail Role View

export const loadSingleWorkPlaceHistory = async (id) => {
	//dispatching with an call back function and returning that

	try {
		const { data } = await axios.get(`workPlaceHistory/${id}`);
		return {
			data,
			message: "Success",
		};
		//dispatching data
	} catch (error) {
		console.log(error.message);
	}
};

// Update workPlaceHistory

export const updateWorkPlaceHistory = async (id, values) => {
	try {
		const { data } = await axios({
			method: "put",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `workPlaceHistory/${id}`,
			data: {
				...values,
			},
		});
		//dispatching data
		toast.success("Updated successful");

		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in updating designation History again");
		console.log(error.message);

		return {
			message: "error",
		};
	}
};

// Delete workPlaceHistory

export const deleteWorkPlaceHistory = async (id) => {
	try {
		const { data } = await axios({
			method: "delete",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `workPlaceHistory/${id}`,
		});
		//dispatching data
		toast.success("Deleted successful");

		return {
			data,
			message: "success",
		};
	} catch (error) {
		toast.error("Error in deleting designation History again");
		console.log(error.message);
		return {
			message: "error",
		};
	}
};
